import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { environment } from "@env/environment";
import { map, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SystemTimeService {
  updateSystemTime$(time: Date): Observable<unknown> {
    const utcDate = new Date(
      Date.UTC(time.getFullYear(), time.getMonth(), time.getDate())
    );
    return this.http.put<Date>(`${environment.BASE_URL}systemtime`, utcDate);
  }

  getSystemTime$(): Observable<Date> {
    return this.http.get<Date>(`${environment.BASE_URL}systemtime`).pipe(
      map((response: Date): Date => {
        return response;
      })
    );
  }

  isSystemTimeTravelOn$(): Observable<boolean> {
    return this.http
      .get<boolean>(`${environment.BASE_URL}systemtime/timetravelactive`)
      .pipe(
        map((response: boolean): boolean => {
          return response;
        })
      );
  }

  isSystemTimeTravelAuthorized$(): Observable<boolean> {
    return this.http
      .get<boolean>(`${environment.BASE_URL}systemtime/systemtimetravel`)
      .pipe(
        map((response: boolean): boolean => {
          return response;
        })
      );
  }

  constructor(private http: HttpClient) {}
}
